import React from 'react';

import { Confirmation } from './Confirmation';

interface Props {
  onSave: Function;
  onCancel: Function;
  onContinue: Function;
  showSpinner?: boolean;
}

export const EditConfirmation: React.FC<Props> = ({ onSave, onCancel, onContinue, showSpinner }) => (
  <Confirmation
    data-testid="edit-confirm"
    question="Do you want to save your changes?"
    primaryText="Yes"
    onPrimaryAction={onSave}
    secondaryText="No"
    onSecondaryAction={onCancel}
    tertiaryText="Keep editing"
    onTertiaryAction={onContinue}
    showSpinner={showSpinner}
  />
);
